import React from 'react';
import {
  Brief,
  CondensedHeader,
  Gutter,
  Icon,
  Layout,
  ReadonlyTextarea,
} from '@axiom/ui';
import type { CandidateWorkFeedItem } from '@axiom/validation';

import type { WorkFeedViewsType } from '../../utils/WorkFeedUtil';
import { WorkFeedUtil } from '../../utils/WorkFeedUtil';

export const WorkFeedCardJobDescription = ({
  workFeedItem,
  view,
  name = 'WORK_FEED_CARD_JOB_DESCRIPTION',
}: {
  workFeedItem: CandidateWorkFeedItem;
  view: WorkFeedViewsType;
  name?: string;
}) => {
  const jobDescription = (workFeedItem.position.description ?? '').trim();
  return (
    <div data-test={name}>
      <Layout position="middle" horizontalGutter="8px">
        {!jobDescription && <Icon name="clock-filled" />}
        <CondensedHeader>Work Description</CondensedHeader>
      </Layout>
      <Gutter bottom="4px" />
      <Brief
        name="JOB_DESCRIPTION_BRIEF"
        briefMaxHeight="143px"
        pattern="secondary"
        expanded={WorkFeedUtil.isSinglePageView(view)}
      >
        <ReadonlyTextarea
          name={jobDescription ? 'DESCRIPTION' : 'missing-jd'}
          value={
            jobDescription ||
            'This opportunity is not accepting expressions of interest. Save it to receive an alert if it starts accepting expressions of interest.'
          }
          formatting="modern"
        />
      </Brief>
    </div>
  );
};
